<div class="bot-container__title" *ngIf="!hedisFirstPassBotEnabled">
  <div class="risk-helper-text --bot">
    {{helperText}}
  </div>
</div>
<div class="attribute-text">
  <form-factory [formGroup]="formGroup" [model]="firstPassBotEnabled" (onChange)="onChangeFirstPassBot()"></form-factory>
</div>

<div [hidden]="!isGridEnabled">
  <div class="firstPass-config-grid">
    <h3 class="title-container bot-config-header">Abstraction Configurations</h3>
    <div class="bot-container__title">
      <div class="bot-container__title--helper-text">
        If AI Assist is selected, the chart will run through EVE and EVE findings
        will be presented to the abstractor to assist in coding.
      </div>
    </div>

    <div class="bot-grid_label">
      <form-factory class="bot-grid_label--selectCheckBox" [formGroup]="formGroup" [model]="allSelectionCheckbox"
                    (onChange)="onAllSelection()"></form-factory>
      <app-basic-grid [configuration]="gridConfiguration" [resizableColumns]="false"></app-basic-grid>
    </div>
    <div class="firstPass-config">
      <ng-container *ngFor="let model of abstractionModels; let j=index; trackBy: trackByIndex">
        <div [ngClass]="[getRowClass(j, abstractionModels.length), getAssistClass(model)]">
          <form-factory [formGroup]="abstractionFormGroup" [model]="model" (onChange)="onSelectFirstPassChange($event, model)"></form-factory>
        </div>
      </ng-container>
    </div>
  </div>
</div>
